import React from "react";

const First = () => (
  <svg
    width="16"
    height="44"
    viewBox="0 0 16 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H16V44H0V0Z" fill="white" />
  </svg>
);

export default First;
